import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { Section } from '@fiverr-private/fit';
import SupportChat from '../../SupportChat';
import { clearFiltersUrl } from '../../../../service/clientNavigation';
import ErrorImage from './images/empty-search-results.png';
import './index.scss';

const BusinessEmptyResults = ({ hasFilters }) => (
    <Section className={classNames('t-a-center', 'empty-search-results')}>
        <div className="error-image">
            <img src={ErrorImage} alt="empty result image"/>
            <small><I18n k={'search_perseus.error_page.made_on_fiverr'} parseMarkup/> <b>onekaa</b></small>
        </div>
        <h2>
            <I18n k={'search_perseus.fiverr_business.no_results_title'}/>
        </h2>
        <SupportChat reason="reason_no-results-listing-chat"/>
        <p>
            <I18n k="search_perseus.fiverr_business.or"/>&nbsp;
            {
                hasFilters ?
                    <a href={clearFiltersUrl()}><I18n k={'search_perseus.error_page.no_results.clear_filters'}/></a> :
                    <I18n k="search_perseus.fiverr_business.start_a_new_search"/>
            }
        </p>

    </Section>
);

export default BusinessEmptyResults;
